module.exports = __webpack_public_path__ + "img/youtube.b24169e3.svg";